<div style="height: 400px" class="col"
  leaflet
  [leafletOptions]="mapOptions"
  (leafletMapReady)="onMapReady($event)"
  (leafletClick)="onClick($event)"
>
</div>
